import cx from 'clsx';

import type { OAISchema } from '~/types/openapi';

import styles from './index.module.css';

const 최대_잔여_재고수량 = 10;

type Props = {
  skuQuantity?: OAISchema['MarketShoppingCartItemResponseV2']['skuQuantity'];
  minimumOrderQuantity?: OAISchema['MarketShoppingCartItemResponseV2']['minimumOrderQuantity'];
  orderPerMultipleQuantity?: OAISchema['MarketShoppingCartItemResponseV2']['orderPerMultipleQuantity'];
  calcMinimumOrderQuantity?: OAISchema['MarketShoppingCartItemResponseV2']['calcMinimumOrderQuantity'];
  className?: string;
};

const ExtraHelpText = ({
  skuQuantity,
  minimumOrderQuantity,
  orderPerMultipleQuantity,
  calcMinimumOrderQuantity,
  className,
}: Props) => {
  const 품절임박 =
    skuQuantity && skuQuantity > 0 && skuQuantity < 최대_잔여_재고수량;

  const 최소주문수량 = minimumOrderQuantity && minimumOrderQuantity > 1;

  const 단위구매 = orderPerMultipleQuantity && orderPerMultipleQuantity > 1;

  return (
    <div className={cx(styles.helpText, className)}>
      {단위구매 && (
        <span className={styles.productCount}>
          {orderPerMultipleQuantity}개 단위로 구매 가능
        </span>
      )}

      {최소주문수량 && (
        <span className={styles.productUnit}>
          최소주문 수량 {calcMinimumOrderQuantity}개
        </span>
      )}
      {품절임박 && (
        <span className={styles.soonSoldOut}>품절임박 {skuQuantity}개</span>
      )}
    </div>
  );
};

export default ExtraHelpText;
